module.exports = __webpack_public_path__ + "img/SLT_0734-Bearbeitet.1f1fb0c7.jpg";